export const allDevicesAllClientsDefs = [
    {
        field: "device_name",
        headerName: "Device Name",
        resizable: true,
    },
    {
        field: "device_type_description",
        headerName: "Device Description",
        resizable: true,
    },
    {
        field: "device_type_code",
        headerName: "Device Type Code",
        resizable: true,
    },
    {
        field: "client_name",
        headerName: "Client Name",
        resizable: true,
    },
    {
        field: "client_id",
        headerName: "Client ID",
        resizable: true,
        hide: true
    },
    {
        field: "firmware",
        headerName: "Firmware",
        hide: true
    },
];
